/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'
import Axios from 'axios'

export default {
    loginAttempt({ dispatch }, payload) {

        // New payload for login action
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify
        }

        // If remember_me is enabled change firebase Persistence
        if (!payload.checkbox_remember_me) {
            // Change firebase Persistence
            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                // If success try to login
                .then(function() {
                    dispatch('login', newPayload)
                })
                // If error notify
                .catch(function(err) {
                    payload.notify({
                        time: 2500,
                        title: 'Error',
                        text: err.message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
        } else {
            // Try to login
            dispatch('login', newPayload)
        }
    },
    login({ commit, state, dispatch }, payload) {

        // If user is already logged in notify and exit
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            return false
        }

        // 11111111111111111111login
        Axios.post('https://signup.dropshipchinapro.com/api/admin/login', {
          "email": payload.userDetails.email,
          "password": payload.userDetails.password,
          }).then(function (res) {
            if(res.data.code !== 200){
              payload.notify({
                title: 'Error',
                text: res.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            } else {
              localStorage.setItem('token',res.data.data.token)
              localStorage.setItem('userName',res.data.data.username)
              localStorage.setItem('userId',res.data.data.id)
              payload.notify({
                  title: 'Login',
                  text: 'You are successfully login!',
                  iconPack: 'feather',
                  icon: 'icon-check',
                  color: 'success'
              });
              router.push({name: 'dashboardSharelink'});
            }
          })
          .catch(function (error) {
            payload.notify({
                title: 'Error',
                text: error.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
          });



    },

    registerUser({dispatch}, payload) {
        // firebase.auth().createUserWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
        //     .then(() => {
        //         payload.notify({
        //             title: 'Account Created',
        //             text: 'You are successfully registered!',
        //             iconPack: 'feather',
        //             icon: 'icon-check',
        //             color: 'success'
        //         });

        //         const newPayload = {
        //             userDetails: payload.userDetails,
        //             notify: payload.notify,
        //             updateUsername: true
        //         }
        //         dispatch('login', newPayload)
        //     }, (error) => {
        //         payload.notify({
        //             title: 'Error',
        //             text: error.message,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     })



        // 111111111111111111
        Axios.post('https://signup.dropshipchinapro.com/api/admin/register', {
            "email": payload.userDetails.email,
            "password": payload.userDetails.password,
            "username": payload.userDetails.username,
            "whatsApp": payload.userDetails.whatsApp,
        }).then(function (res) {
          if(res.data.code !== 200){
            payload.notify({
              title: 'Error',
              text: res.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
             });
          } else {
            payload.notify({
                title: 'Account Created',
                text: 'You are successfully registered!',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
            const newPayload = {
                userDetails: payload.userDetails,
                notify: payload.notify,
                updateUsername: true
            }
            dispatch('login', newPayload)
          }
        })
        .catch(function (error) {
          payload.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
          });
        });
    },
    updateUsername({ commit }, payload) {
        payload.user.updateProfile({
            displayName: payload.username
        }).then(() => {

            // If username update is success
              // update in localstorage
            let newUserData = Object.assign({}, payload.user.providerData[0])
            newUserData.displayName = payload.username
            commit('UPDATE_AUTHENTICATED_USER', newUserData)

            // If reload is required to get fresh data after update
              // Reload current page
            if(payload.isReloadRequired) {
                router.push(router.currentRoute.query.to || '/')
            }
        }).catch((err) => {
              payload.notify({
                time: 8800,
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        })
    },
    updateAuthenticatedUser({ commit }, payload) {
        commit('UPDATE_AUTHENTICATED_USER', payload)
    }
}
